var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 overflow-hidden"},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":require("@/assets/images/home-sith-new.png")}})])
}]

export { render, staticRenderFns }